import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import ViewButton from "../../../../common/batches/ViewButton";
import { indianCurrencyFormater } from "../../../../helpers/functions/currencyFormater";
import { errorToast } from "../../../../react-toastfiy/toast";
import { bussArray, docArray, partnerFields } from "../common/fields";
import useOnboardingWorkflow from "../hooks/useOnboardingWorkflow";

const CreateTAUsers = () => {
  const location = useLocation();
  const id = location.pathname.split(":")[1];
  const data = location?.state?.data;
  const {
    selected,
    setSelected,
    formData,
    setFormData,
    buttonLoader,
    setButtonLoader,
    formUpload,
    setFormUpload,
    handleSubmit,
    handleChangebussDetails,
    handleUpload,
    documentUploadProgress,
    setDocumentUploadProgress,
    handleDeletePartner,
    loadingTADetails,
    setLoadingTADetails,
  } = useOnboardingWorkflow({
    Userdata: data,
    taOnboardingCaseId: id ? id : "",
  });

  useEffect(() => {
    if (formData?.taOnboardingCaseId === "") {
      setLoadingTADetails(false);
    }
    const uploadDoclist = Object.entries(formUpload).filter(
      ([key, value], index) => value !== ""
    );
    const progress =
      (uploadDoclist.length * 100) / Object.entries(formUpload).length;
    setDocumentUploadProgress(progress);
  }, [formUpload]);

  return (
    <>
      <div className="container mt-2">
        <div
          className=" p-2 bg-glass rounded-2"
          style={{
            zIndex: 3,
            top: 0,
            position: "sticky",
            backgroundColor: "rgb(255,255,255)",
          }}
        >
          {id && id !== "" ? <h4>Update TA User</h4> : <h4>Create TA User</h4>}
        </div>
        {id !== "" && id !== undefined ? (
          <>
            <div className="d-flex flex-wrap justify-content-between">
              <div className="col-12 col-md-3">
                <div
                  className="shadow-sm p-3 mb-2 border mt-3"
                  style={{
                    backgroundColor: "rgb(255,255,255)",
                    minHeight: "21rem",
                    maxHeight: "21rem",
                  }}
                >
                  <div className="col-12">
                    <div
                      className="col-12  text-bold"
                      style={{
                        fontWeight: 600,
                        fontFamily: "ui-monospace",
                      }}
                    >
                      Dealer Information
                    </div>
                    <div className="col-12  text-bold">
                      <div
                        style={{
                          fontWeight: 400,
                          fontFamily: "none",
                          color: "rgb(192,190,190)",
                        }}
                      >
                        ID
                      </div>
                      <div
                        className=""
                        style={{
                          fontWeight: 600,
                          fontFamily: "none",
                          marginTop: "-2px",
                        }}
                      >
                        {formData?.taOnboardingCaseId}
                      </div>
                    </div>
                    <div className="col-12  text-bold">
                      <div
                        style={{
                          fontWeight: 400,
                          fontFamily: "none",
                          color: "rgb(192,190,190)",
                        }}
                      >
                        Location
                      </div>
                      <div
                        className=""
                        style={{
                          fontWeight: 600,
                          fontFamily: "none",
                          marginTop: "-2px",
                        }}
                      >
                        {formData?.companyAddress}
                      </div>
                    </div>
                    <div className="col-12  text-bold">
                      <div
                        style={{
                          fontWeight: 400,
                          fontFamily: "none",
                          color: "rgb(192,190,190)",
                        }}
                      >
                        TA User Name
                      </div>
                      <div
                        className=""
                        style={{
                          fontWeight: 600,
                          fontFamily: "monospace",
                          marginTop: "-2px",
                        }}
                      >
                        {formData?.personName}
                      </div>
                    </div>
                    <div className="col-12  text-bold">
                      <div
                        style={{
                          fontWeight: 400,
                          fontFamily: "none",
                          color: "rgb(192,190,190)",
                        }}
                      >
                        Phone
                      </div>
                      <div
                        className=""
                        style={{
                          fontWeight: 600,
                          fontFamily: "none",
                          marginTop: "-2px",
                        }}
                      >
                        {formData?.taUserPhone}
                      </div>
                    </div>
                    <div className="col-12  text-bold">
                      <div
                        style={{
                          fontWeight: 400,
                          fontFamily: "none",
                          color: "rgb(192,190,190)",
                        }}
                      >
                        Email
                      </div>
                      <div
                        className="flex-wrap"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          wordBreak: "break-word",
                          fontWeight: 600,
                          fontFamily: "none",
                          marginTop: "-2px",
                        }}
                      >
                        {formData?.email}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-9" style={{ marginRight: "-10px" }}>
                <div
                  className="shadow-sm p-3 mb-2 border mt-3 onBordingCard"
                  style={{
                    backgroundColor: "rgb(255,255,255)",
                    maxHeight: "21rem",
                    minHeight: "21rem",
                  }}
                >
                  <div
                    className="col-12 mb-2 text-bold"
                    style={{
                      fontWeight: 600,
                      fontFamily: "ui-monospace",
                    }}
                  >
                    Documents Status
                  </div>
                  <div className="d-flex flex-wrap justify-content-between flex-sm-row gap-1 ">
                    <div
                      className="onBordingScreenSize"
                      style={{
                        fontSize: "10px",
                        backgroundColor: "rgb(220,252,231)",
                        color: "rgb(122,175,159)",
                      }}
                    >
                      <h5 className="text-center m-0">{formData?.verified}</h5>

                      <h6 className="text-center">Verified</h6>
                    </div>
                    <div
                      className="onBordingScreenSize"
                      style={{
                        fontSize: "10px",
                        fontWeight: 500,
                        backgroundColor: "rgb(254,226,226)",
                        color: "rgb(208,122,128)",
                      }}
                    >
                      <h5 className="text-center m-0">
                        {" "}
                        <h5 className="text-center m-0">
                          {formData?.rejected}
                        </h5>
                      </h5>
                      <h6 className="text-center">Rejected</h6>
                    </div>
                    <div
                      className="onBordingScreenSize"
                      style={{
                        fontSize: "10px",
                        fontWeight: 500,
                        backgroundColor: "rgb(254,216,216)",
                        color: "rgb(208,122,128)",
                      }}
                    >
                      <h5 className="text-center m-0">
                        {" "}
                        <h5 className="text-center m-0">
                          {" "}
                          {formData?.missing}
                        </h5>
                      </h5>
                      <h6 className="text-center">Missing</h6>
                    </div>
                    <div
                      className="onBordingScreenSize"
                      style={{
                        fontSize: "10px",
                        fontWeight: 500,
                        backgroundColor: "rgb(243,244,246)",
                        color: "rgb(192,172,165)",
                      }}
                    >
                      <h5 className="text-center m-0">
                        <h5 className="text-center m-0">{formData?.pending}</h5>
                      </h5>
                      <h6 className="text-center">Pending</h6>
                    </div>
                  </div>
                  {/* <div
                      className="col-12 mb-2 text-bold text-end"
                      style={{
                        fontWeight: 600,
                        fontFamily: "ui-monospace",
                        marginTop: isMediumDevice ? "10rem" : "5rem",
                      }}
                    >
                      <button className="btn btn-danger">
                        <i
                          class="bi bi-trash"
                          style={{ fontSize: "15px" }}
                      
                        ></i>{" "}
                        Delete Case
                      </button>
                    </div> */}
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="shadow-sm p-3 mb-2 mt-2 bg-glass">
            <div className="row">
              <div className="col-12 col-md-4">
                <span> User Name</span>: <strong>{formData?.personName}</strong>
              </div>
              <div className="col-12 col-md-4">
                <span> User Phone</span>:{" "}
                <strong>{formData?.taUserPhone}</strong>
              </div>
              <div className="col-12 col-md-4">
                <span> User State</span>: <strong>{formData?.state}</strong>
              </div>
            </div>
          </div>
        )}

        <div
          className="btn-group mt-2 p-1"
          role="group"
          aria-label="Basic radio toggle button group"
          style={{
            backgroundColor: "rgb(244,244,245)",
            width: "100%",
            display: "flex",
          }}
        >
          <input
            type="radio"
            className="btn-check"
            name="btnradio"
            id="bussRadio"
            autoComplete="off"
            checked={selected === "buss"}
            onChange={() => setSelected("buss")}
          />
          <label
            className="btn"
            htmlFor="bussRadio"
            style={{
              backgroundColor:
                selected === "buss" ? "#fff" : "rgb(244,244,245)",
              color: selected === "buss" ? "#000" : "#999",
              fontWeight: selected === "buss" ? 500 : 400,
              border: "0px solid #ccc",
              borderLeft: "none",
              borderRadius: "0",
              padding: "6px 12px",
              flex: 1,
              textAlign: "center",
            }}
          >
            <i
              className="bi bi-person"
              style={{
                marginRight: "6px",
                color: selected === "buss" ? "rgb(75,107,134)" : "#ccc",
              }}
            ></i>
            Business Details
          </label>

          <input
            type="radio"
            className="btn-check"
            name="btnradio"
            id="docRadio"
            autoComplete="off"
            checked={selected === "doc"}
            onChange={() =>
              errorToast("Business details must be completed first")
            }
          />
          <label
            className="btn"
            htmlFor="docRadio"
            style={{
              backgroundColor: selected === "doc" ? "#fff" : "rgb(244,244,245)",
              color: selected === "doc" ? "#000" : "#999",
              fontWeight: selected === "doc" ? 500 : 400,
              border: "0px solid #ccc",
              borderRadius: "0",
              padding: "6px 12px",
              flex: 1,
              textAlign: "center",
            }}
          >
            <i
              className="bi bi-file-earmark-text"
              style={{
                marginRight: "6px",
                color: selected === "doc" ? "rgb(75,107,134)" : "#ccc",
              }}
            ></i>
            Documents Collection
          </label>
        </div>
        {selected === "doc" && formData?.taOnboardingCaseId !== "" ? (
          <div className="shadow-sm p-3 mb-4 border rounded mt-3 bg-light bg-glass">
            <h5 className="mb-3">Upload Documents</h5>
            <div className="row g-3">
              {docArray.map(({ id, label }) => {
                const uploadedDoc = Object.entries(formUpload).find(
                  (doc) => doc.documentName === id
                );
                return (
                  <>
                    <div className="col-12 col-md-6 mb-2" key={id}>
                      <div className="border rounded p-3 d-flex justify-content-between align-items-center bg-white shadow-sm">
                        <>
                          <div className="d-flex align-items-center gap-3">
                            <i
                              className="bi bi-patch-check-fill"
                              style={{
                                color: "rgb(6,102,60)",
                                fontSize: "1.2rem",
                              }}
                            />
                            <strong>{label}</strong>
                          </div>

                          {uploadedDoc && uploadedDoc.documentPath ? (
                            <ViewButton
                              file={uploadedDoc.documentPath}
                              fileName={id}
                            />
                          ) : (
                            <div>
                              <label
                                htmlFor={id}
                                className="btn btn-outline-primary btn-sm mb-0"
                              >
                                Upload
                                <input
                                  type="file"
                                  id={id}
                                  name={id}
                                  style={{ display: "none" }}
                                  onChange={(e) => handleUpload(e, id)}
                                />
                              </label>
                            </div>
                          )}
                        </>
                        {/* )} */}
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        ) : (
          <>
            {loadingTADetails ? (
              <div>loading ... </div>
            ) : (
              <form onSubmit={handleSubmit} validate>
                <div
                  className="shadow-sm p-3 mb-4 bg-glass rounded mt-3 mb-3"
                  // style={{ backgroundColor: "rgb(255,254,255)" }}
                >
                  <h5 className="mb-3">Business Details</h5>
                  {formData?.taOnboardingCaseId !== "" &&
                    formData?.isCaseBusinessDetailsRejectedByBa && (
                      <>
                        <div
                          className=""
                          style={{
                            backgroundColor: "rgb(253,241,241)",
                            color: "rgb(202,73,101)",
                            marginTop: "15px",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            paddingLeft: "5px",
                          }}
                        >
                          Rejection Reason :{" "}
                          <span className="text-align-end text-danger">
                            {formData?.caseBusinessDetailsRejectionReason}
                          </span>
                        </div>
                      </>
                    )}
                  <hr />
                  <div className="row mb-2">
                    {bussArray.map(
                      ({
                        id,
                        label,
                        type,
                        options = [],
                        isMulti = false,
                        disabled = false,
                        placeholder,
                        required,
                      }) => {
                        if (id === "companyAddress") {
                          return (
                            <div
                              className="col-12 col-md-6 mb-2"
                              key={id}
                              // style={{ marginTop: "2rem" }}
                            >
                              <label htmlFor={id} className="form-label">
                                {label}
                              </label>
                              {required ? (
                                <strong className="text-danger">*</strong>
                              ) : (
                                ""
                              )}

                              <textarea
                                type={type}
                                className="form-control"
                                id={id}
                                name={id}
                                value={
                                  id === "monthlyAverageSalesVolume"
                                    ? indianCurrencyFormater(formData[id], 0)
                                    : formData[id] || ""
                                }
                                onChange={(e) => {
                                  handleChangebussDetails(e, id, type);
                                }}
                                disabled={disabled}
                                placeholder={placeholder}
                                onWheel={(e) => e.target.blur()}
                                required={required}
                              />
                            </div>
                          );
                        }

                        const showNoOfPartners =
                          [
                            "Partnership",
                            // "partnership",
                            "Private limited (Pvt Ltd)",
                            // "pvt_ltd",
                          ].includes(formData.businessType) &&
                          id === "noOfPartners";
                        let showFirmPan =
                          ["Partnership", "Private limited (Pvt Ltd)"].includes(
                            formData.businessType
                          ) && id === "firmPan";

                        const showUserPan =
                          ["Individual", "Proprietor"].includes(
                            formData.businessType
                          ) && id === "userPan";

                        if (
                          (id === "noOfPartners" && !showNoOfPartners) ||
                          (id === "firmPan" && !showFirmPan)
                        ) {
                          return null;
                        }
                        if (
                          (id !== "noOfPartners" && showNoOfPartners) ||
                          (id === "userPan" && !showUserPan)
                        ) {
                          return null;
                        }
                        const showBusinessName =
                          [
                            "Partnership",
                            "Proprietor",
                            "Private limited (Pvt Ltd)",
                          ].includes(formData.businessType) &&
                          id === "companyName";

                        if (id === "companyName" && !showBusinessName) {
                          return null;
                        }

                        if (id === "noOfPartners" && showNoOfPartners) {
                          return (
                            <React.Fragment key={id}>
                              <div className="col-12 col-md-6 mb-2">
                                <label htmlFor={id} className="form-label">
                                  {label}
                                </label>
                                {required ? (
                                  <strong className="text-danger">*</strong>
                                ) : (
                                  ""
                                )}

                                <input
                                  className="form-control"
                                  id={id}
                                  name={id}
                                  type={type}
                                  required={required}
                                  value={formData[id] >= 0 ? formData[id] : 0}
                                  onChange={(e) => {
                                    handleChangebussDetails(e, id, type);
                                  }}
                                  onBlur={(e) => {
                                    if (id === "monthlyAverageSalesVolume") {
                                      const numeric = formData[id];
                                      const formatted =
                                        indianCurrencyFormater(numeric);
                                      setFormData((prevData) => ({
                                        ...prevData,
                                        [id]: formatted,
                                      }));
                                    }
                                  }}
                                  onFocus={(e) => {
                                    if (id === "monthlyAverageSalesVolume") {
                                      const unformatted =
                                        formData[id]?.replace(/[^0-9]/g, "") ||
                                        "";
                                      setFormData((prevData) => ({
                                        ...prevData,
                                        [id]: unformatted,
                                      }));
                                    }
                                  }}
                                  placeholder={placeholder}
                                  onWheel={(e) => e.target.blur()}
                                />
                              </div>

                              {formData.noOfPartners >= 0 &&
                                !isNaN(Number(formData.noOfPartners)) &&
                                [...Array(Number(formData.noOfPartners))].map(
                                  (_, index) => (
                                    <React.Fragment key={index}>
                                      <div className="d-flex flex-wrap justify-content-between">
                                        <h6 className="mt-2 mb-2">
                                          Partner {index + 1} Details
                                        </h6>

                                        {formData?.taOnboardingCaseId !== "" &&
                                          formData?.partnerDetails?.length >
                                            0 &&
                                          formData?.partnerDetails[index]
                                            ?.partnerID && (
                                            <div className="col-3 text-end mt-2">
                                              <i
                                                class="bi bi-trash"
                                                style={{ fontSize: "20px" }}
                                                onClick={(e) => {
                                                  handleDeletePartner(
                                                    e,
                                                    formData?.taOnboardingCaseId,
                                                    formData?.partnerDetails[
                                                      index
                                                    ]?.partnerID
                                                  );
                                                }}
                                              ></i>
                                            </div>
                                          )}
                                      </div>
                                      {index === 0 && (
                                        <hr className="soften mt-2 mb-2" />
                                      )}

                                      {partnerFields.map(
                                        ({
                                          id,
                                          label,
                                          type,
                                          options = [],
                                          placeholder,
                                          required,
                                        }) => (
                                          <>
                                            <div
                                              className="col-12 col-md-4"
                                              key={`${id}_${index}`}
                                            >
                                              <label
                                                htmlFor={`${id}_${index}`}
                                                className="form-label"
                                              >
                                                {`${label} ( Partner ${
                                                  index + 1
                                                })`}
                                                {required ? (
                                                  <strong className="text-danger">
                                                    *
                                                  </strong>
                                                ) : (
                                                  ""
                                                )}
                                              </label>

                                              {type === "select" ? (
                                                <select
                                                  className="form-select"
                                                  id={`${id}_${index}`}
                                                  name={`partner_${
                                                    index + 1
                                                  }_${id}`}
                                                  onChange={
                                                    handleChangebussDetails
                                                  }
                                                  value={
                                                    formData?.partnerDetails[
                                                      index
                                                    ]?.[id]
                                                  }
                                                >
                                                  <option value="">
                                                    Select...
                                                  </option>
                                                  {options.map((opt) => (
                                                    <option
                                                      key={opt}
                                                      value={opt}
                                                    >
                                                      {opt}
                                                    </option>
                                                  ))}
                                                </select>
                                              ) : (
                                                <input
                                                  className="form-control"
                                                  id={`${id}_${index}`}
                                                  type={type}
                                                  name={`partner_${
                                                    index + 1
                                                  }_${id}`}
                                                  value={
                                                    formData?.partnerDetails[
                                                      index
                                                    ]?.[id]
                                                  }
                                                  placeholder={placeholder}
                                                  onChange={(e) => {
                                                    handleChangebussDetails(
                                                      e,
                                                      id,
                                                      type
                                                    );
                                                  }}
                                                  required={required}
                                                  onWheel={(e) =>
                                                    e.target.blur()
                                                  }
                                                />
                                              )}
                                            </div>
                                          </>
                                        )
                                      )}
                                      <hr className="soften mt-4 mb-3" />
                                    </React.Fragment>
                                  )
                                )}
                            </React.Fragment>
                          );
                        }

                        if (id === "firmPan" && showFirmPan) {
                          return (
                            <div className="col-12 col-md-6 mb-2" key={id}>
                              <label htmlFor={id} className="form-label">
                                {label}
                              </label>
                              {required ? (
                                <strong className="text-danger">*</strong>
                              ) : (
                                ""
                              )}
                              <input
                                type={type}
                                className="form-control"
                                id={id}
                                name={id}
                                required={required}
                                value={formData[id] || ""}
                                onChange={(e) => {
                                  handleChangebussDetails(e, id, type);
                                }}
                                onBlur={(e) => {
                                  if (id === "monthlyAverageSalesVolume") {
                                    const numeric = formData[id];
                                    const formatted =
                                      indianCurrencyFormater(numeric);
                                    setFormData((prevData) => ({
                                      ...prevData,
                                      [id]: formatted,
                                    }));
                                  }
                                }}
                                onFocus={(e) => {
                                  if (id === "monthlyAverageSalesVolume") {
                                    const unformatted =
                                      formData[id]?.replace(/[^0-9]/g, "") ||
                                      "";
                                    setFormData((prevData) => ({
                                      ...prevData,
                                      [id]: unformatted,
                                    }));
                                  }
                                }}
                                placeholder={placeholder}
                                onWheel={(e) => e.target.blur()}
                              />
                            </div>
                          );
                        }

                        return (
                          <div className="col-12 col-md-6 mb-2" key={id}>
                            <label htmlFor={id} className="form-label">
                              {label}
                            </label>
                            {required ? (
                              <strong className="text-danger">*</strong>
                            ) : (
                              ""
                            )}
                            {type === "select" ? (
                              <Select
                                id={id}
                                name={id}
                                isMulti={isMulti}
                                required={required}
                                options={options.map((opt) => ({
                                  label: opt,
                                  value: opt,
                                }))}
                                value={
                                  isMulti
                                    ? (formData[id] || []).map((val) => ({
                                        label: val,
                                        value: val,
                                      }))
                                    : formData[id]
                                    ? {
                                        label: formData[id],
                                        value: formData[id],
                                      }
                                    : null
                                }
                                onChange={(selected) => {
                                  const value = isMulti
                                    ? selected.map((item) => item.value)
                                    : selected?.value || "";
                                  handleChangebussDetails({
                                    target: { name: id, value },
                                    type,
                                  });
                                }}
                                placeholder={placeholder}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                              />
                            ) : (
                              <input
                                type={type}
                                className="form-control"
                                id={id}
                                name={id}
                                value={
                                  id === "monthlyAverageSalesVolume"
                                    ? indianCurrencyFormater(formData[id], 0)
                                    : formData[id] || ""
                                }
                                onChange={(e) => {
                                  handleChangebussDetails(e, id, type);
                                }}
                                disabled={disabled}
                                placeholder={placeholder}
                                onWheel={(e) => e.target.blur()}
                                style={
                                  id === "companyAddress"
                                    ? { height: "120px" }
                                    : {}
                                }
                                required={required}
                              />
                            )}
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
                <div
                  className="d-flex justify-content-end my-2"
                  style={{
                    bottom: -23,
                    zIndex: 5,
                    position: "sticky",
                    // backgroundColor: "rgb(255,255,255)",
                  }}
                >
                  {buttonLoader ? (
                    <button
                      className="btn btn-primary"
                      type="button"
                      disabled
                      id="loadingBtnTp"
                    >
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Loading...
                    </button>
                  ) : id && id !== "" ? (
                    <button
                      className="btn btn-success"
                      type="submit"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Update
                    </button>
                  ) : (
                    <button
                      className="btn btn-primary"
                      type="submit"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Submit
                    </button>
                  )}
                </div>
              </form>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default CreateTAUsers;
